module.exports = __webpack_public_path__ + "img/12.f83f161.png";